(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("projection-grid-core"));
	else if(typeof define === 'function' && define.amd)
		define(["projection-grid-core"], factory);
	else if(typeof exports === 'object')
		exports["ProjectionGridVue"] = factory(require("projection-grid-core"));
	else
		root["ProjectionGridVue"] = factory(root["projection-grid-core"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_16__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition